<template>
  <div class="page">
    <div class="title">{{ detail.title }}</div>
    <div class="content">
      <p class="page-text" v-html="detail.content"></p>
      <div class="goto-bg">
        <button class="goto" @click="gotoLogin">返回</button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "about",
  data() {
    return {
      detail: {},
      activeId: 0,
    };
  },
  created() {
    this.activeId = this.$route.query.activeid;
    this.getArticle();
  },
  methods: {
    getArticle: async function () {
      // 出兑列表
      let active_Id = this.activeId ? this.activeId : 10001;
      const res = await this.http.get("/article/detail", {
        articleId: active_Id,
      });
      // api/article/detail&articleId=10001
      if (res.data.status === 200) {
        this.detail = res.data.data.detail;
      }
    },
    gotoLogin() {
      this.$router.replace({
        path: "/login",
      });
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep img {
  width: 100%;
}
.page {
  position: relative;
  background: #f7f8f9;
  min-height: 100vh;
  .title {
    font-weight: 500;
    font-size: 16px;
    padding-top: 20px;
    margin: 0px auto 20px;
    text-align: center;
  }
  .content {
    font-size: 14px;
    line-height: 28px;
    padding: 0px 15px;
  }
  .goto-bg {
    position: fixed;
    width: 100%;
    left: 0px;
    padding: 20px 5%;
    bottom: 0px;
    background: #fff;
  }
  .goto {
    width: 90%;
    text-align: center;
    border-radius: 6px;
    border: 1px solid #979797;
    height: 45px;
    line-height: 45px;
  }
}
</style>
